module.exports = __webpack_public_path__ + "img/evaldone.9192b0a5.svg";